import * as React  from "react";
import  ModalContext  from "./ModalContext";

const useModal = () => React.useContext(ModalContext);

export default useModal;
